<script setup>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { ref, computed } from "vue";
import Image from './Image.vue';
import Text from './Text.vue';

const sliderOptions = {
    rewind: true,
    type: 'slide',
    perPage: 1,
    autoplay: true,
    pagination: true,
    arrows: false,
    padding: '0px',
    focus: 'center',
    autoWidth: false,
    direction: 'ttb',
    height: '520px',
    classes: {
        pagination: 'splide__pagination splide__pagination_circle'
    },
    breakpoints: {
        992: {
            direction: false,
            height: 'auto',
        },
        640: {
            direction: false,
            height: 'auto',
            classes: {
                pagination: 'splide__pagination splide__pagination_circle splide__pagination_mobile'
            },
        },
    }
};

const classes = ref([
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1756138211/BrandRecognition_n8pxpt.png',
        name: 'Brand recognition-get instant credibility backed by a national brand',
        heading: 'Brand recognition-'

    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/ExpertClassPlans_wjpx8r.png',
        name: 'focus on great coaching, not lesson planning',
        heading: 'Expert class plans-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/Extra_Income_rr0zgz.png',
        name: 'get paid for teaching classes and earn commission on product sales',
        heading: 'Extra income-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/FlexibleScheduling_ymnrnz.png',
        name: 'teach kickboxing classes anywhere, anytime',
        heading: 'Flexible scheduling-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/InnovativeTech_yefjsl.png',
        name: 'access proprietary tech right from your phone to help run classes smoothly',
        heading: 'Innovatice tech-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/OnlineVisibility_i4w3nf.png',
        name: 'attrach clients with a local listing on our national ILKB website',
        heading: 'Online visibility-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/WholesaleEquipment_oxc5g5.png',
        name: 'unlock special rates on fitness gear to boost resale opportunities',
        heading: 'Wholesale equipment-'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549100/WorldClassSupport_kpfjli.png',
        name: 'access to expert guidance, ongoing training, and a dedicated support team',
        heading: 'World-class support-'
    },
]);

</script>
<template>
    <template v-if="isMobile">
        <Text type="H1" text="Class structure" class="mb-30 font-size-mobile-36" />
    </template>


    <Splide :options="sliderOptions">
        <SplideSlide v-for="(classDetails, index) in classes" :key="index">
            <figure>
                <img class="slide-img" :src="classDetails.image_link" alt="">
                <figcaption class="slide-caption">
                    <span class="caption-heading">{{ classDetails.heading }}</span>
                    {{ classDetails.name }}
                </figcaption>
            </figure>
        </SplideSlide>
    </Splide>

</template>
<style scoped>
.slide-img {
    height: 350px;
    width: 100%;
    object-fit: cover;
}

.slide-caption {
    width: 100%;
    padding: 20px;
    background-color: #181843;
    color: #fff;
    font-size: 16px;
    line-height: 1.4;
}

.caption-heading {
    display: block;
    font-weight: bold;
    margin-bottom: 8px;
}

/* Only color overrides (apply everywhere) */
:deep(.splide__pagination button) {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ccc !important;
    /* inactive grey */
    opacity: 0.6;
    transition: all 0.3s ease;
}

:deep(.splide__pagination button.is-active) {
    background: #C5A254 !important;
    /* GOLD active */
    opacity: 1;
    transform: scale(1.3);
}

/* Responsive: on mobile, force dots into row below */
@media (max-width: 992px) {
    :deep(.splide__pagination) {
        display: flex !important;
        justify-content: center !important;
        gap: 10px;
        margin-top: 15px;
        position: relative !important;
        top: auto !important;
        right: auto !important;
        transform: none !important;
    }

    .slide-img {
        height: auto;
    }

    .slide-caption {
        font-size: 14px;
        padding: 15px;
    }
}
</style>
